import { lazy } from "react";

import TextToCarousel from "./text-to-carousel";
import CarouselGenerator from "./carousel-generator";
import Saved from "./saved";
import GenerateWithAISelection from "./generate-with-ai-selection";

const List = lazy(() => import("./list"));
const Editor = lazy(() => import("./editor"));

export {
  List,
  Editor,
  TextToCarousel,
  Saved,
  CarouselGenerator,
  GenerateWithAISelection
};
